import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Select } from 'antd'

// NOTE: `catmanId` is the numeric primary key; ProductCategory's GraphQL `id`
// resolves to the SEO slug instead. Every consumer here (the order's
// product_category_id, the /search product_category_id filter) needs the PK.
const PRODUCT_CATEGORIES_QUERY = gql`
    query ProductCategories($query: String){
        productCategories(query: $query, limit: 20){
            catmanId
            name
        }
    }
`

const renderOptions = (options = []) => options.map(({ catmanId, name }) => {
    return <Select.Option key={catmanId} value={catmanId}>{name}</Select.Option>
})

const ProductCategorySelector = ({
    activeFirstOptionAsDefault,
    defaultProductCategory,
    onChange,
    value,
    ...restProps
}) => {
    const { i18n } = useTranslation()
    const [initDefault, setDefault] = useState(false)
    const [selected, setSelected] = useState(value)
    const [query, setQuery] = useState(defaultProductCategory && defaultProductCategory.name)
    const { loading, data } = useQuery(PRODUCT_CATEGORIES_QUERY, {
        variables: { query },
        onCompleted: ({ productCategories }) => {
            if (initDefault) return null

            initialFirstOptionAsDefault(productCategories)

            setDefault(true)
        }
    })

    useEffect(() => {
        if (selected !== value) {
            handleChange(value)
        }
    }, [value])

    const initialFirstOptionAsDefault = (productCategories) => {
        const firstProductCategory = productCategories[0]

        if (!activeFirstOptionAsDefault || !firstProductCategory) return null

        handleChange(firstProductCategory.catmanId)
    }

    const handleChange = (value, option = {}) => {
        onChange(value, option)
        setSelected(value)
    }

    const handleSearch = value => {
        setQuery(value)
    }

    return (
        <Select
            allowClear
            filterOption={false}
            loading={loading}
            onChange={handleChange}
            onSearch={handleSearch}
            placeholder={i18n.t('searchCategory')}
            showSearch
            value={selected}
            {...restProps}
        >
            {renderOptions(data && data.productCategories)}
        </Select>
    )
}

ProductCategorySelector.propTypes = {
    activeFirstOptionAsDefault: PropTypes.bool,
    defaultProductCategory: PropTypes.object,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ProductCategorySelector.defaultProps = {
    activeFirstOptionAsDefault: false,
    onChange: () => {}
}

export default ProductCategorySelector
